import React, { useState } from 'react';
import { EditTwoTone } from '@ant-design/icons';
import { Modal, Form, Input } from 'antd';
import { useDispatch } from 'react-redux';
import { updateResource } from '../../../redux/resources/actions';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const EditResource = ({ item }) => {
    const dispatch = useDispatch();
    const [Model_visible, setModel_visible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        onFill();
        setModel_visible(true);
    };

    const onFill = () => {
        form.setFieldsValue(item);
    };

    const hideModal_Ok = () => {
        form.submit();
    };

    const form_onfinish = (values) => {
        dispatch(updateResource(item._id, values));
        form.resetFields();
        setModel_visible(false);
    };

    const hideModal_Cancel = () => {
        setModel_visible(false);
        form.resetFields();
    };

    return (
        <>
            <EditTwoTone twoToneColor='blue' key="edit" onClick={showModal} />
            <Modal
                title="Edit Resource"
                visible={Model_visible}
                onOk={hideModal_Ok}
                onCancel={hideModal_Cancel}
                okText="Submit"
                cancelText="Close"
            >
                <Form
                    {...layout}
                    name="basic"
                    form={form}
                    onFinish={form_onfinish}
                    initialValues={{ remember: false }}
                >
                    <Form.Item
                        label="Resource Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter the resource name!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default EditResource;
